import { render } from "./RentalHistory.vue?vue&type=template&id=351ad62c"
import script from "./RentalHistory.vue?vue&type=script&lang=js"
export * from "./RentalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Customers/RentalHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "351ad62c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('351ad62c', __exports__)) {
    api.reload('351ad62c', __exports__)
  }
  
  module.hot.accept("./RentalHistory.vue?vue&type=template&id=351ad62c", () => {
    api.rerender('351ad62c', render)
  })

}


export default __exports__